// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorModule_container__Ou74k","error_info":"ErrorModule_error_info__ZxtV1","btn_container":"ErrorModule_btn_container__zuFW9"};